import * as React from 'react';
import {Helmet} from 'react-helmet';

import useLabelTranslation from 'src/hooks/useLabelTranslation';

import {
  BodyMedium,
  SubTitleLarge,
} from '@spaced-out/ui-design-system/lib/components/Text';

import css from './404.css';


type NotFoundProps = {
  title?: string;
};

const NotFound = ({title}: NotFoundProps) => {
  const {t} = useLabelTranslation();

  const pageTitle = title || t('404_Not_Found', '404 Not Found');

  return (
    <div className={css.container}>
      {/* @ts-expect-error - TS2786 - 'Helmet' cannot be used as a JSX component. */}
      <Helmet title={pageTitle} />

      <div className={css.content}>
        <div className={css.errorCode} />
        <div className={css.errorTextContainer}>
          <SubTitleLarge className={css.errorTextTitle}>
            {`${t(
              'Looks_like_this_job_just_left_the_building',
              'Looks like this job just left the building',
            )}.`}
          </SubTitleLarge>
          <BodyMedium className={css.errorTextDescription}>
            {`${t('But_don\'t_worry', 'But don\'t worry')} -- ${t(
              'we\'re_great_at_finding_the_right_match',
              'we\'re great at finding the right match',
            )}. ${t(
              'Let\'s_get_you_back_on_track_and_closer_to_your_next_opportunity',
              'Let\'s get you back on track and closer to your next opportunity',
            )}.`}
          </BodyMedium>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
